import { BaseRouteService } from "./BaseRouteService";

export class InventoryService extends BaseRouteService {
    /**
     * Haalt de huidige inventory op
     * @returns Een lijst van items in de inventaris
     */
    public async getInventory(): Promise<string[]> {
        try {
            return await this.getJsonApi("yassin/inventory");
        }
        catch (error) {
            console.error("Fout bij het ophalen van de inventaris:", error);
            throw new Error("Kan de inventaris niet ophalen. Probeer het later opnieuw.");
        }
    }
}
